// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","title":"Header_title__hzAP-"};